import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'Components/Button';
import Card from 'Components/Card';
import ControllerTextArea from 'Components/ControllerTextArea';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { CompromisoSchema } from 'Services/yup/form';
import ControllerDatePicker from 'Components/ControllerDatePicker';
import ControllerInput from 'Components/ControllerInput';

const CompromisoModal = (props) => {
  const { changeState, params = {}, actionOK } = props;
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    console.log(params);
    setMessage('');
  }, []);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      fechaCompromiso: '',
      montoCompromiso: '',
      observaciones: ''
    },
    resolver: yupResolver(CompromisoSchema)
  });

  const submit = async (data) => {
    await actionOK({ ...data, idCredito: params.folioCredito }, setLoader);
    reset();
  };

  const closeModal = () => {
    reset();
    changeState(false);
  };

  return (
    <Card>
      <button
        type="button"
        className="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
        data-modal-hide="popup-modal"
        onClick={() => closeModal()}>
        <FontAwesomeIcon icon={['fa', 'close']} size="2x" />
      </button>
      <div className="text-center bg-gray-100">
        <h3 className="text-lg font-normal m-2">{`La fecha compromiso para el credito`}</h3>
        <h3 className="text-lg font-normal m-2">
          <strong>{`${params.etiquetaCredito}`}</strong>
        </h3>
        <h3 className="text-lg font-normal m-2">{`${params.nombreCompleto}`}</h3>
        <div className="m-5">
          <ControllerDatePicker
            control={control}
            name="fechaCompromiso"
            error={errors?.fechaCompromiso}
            placeholder="Fecha de compromiso"
          />
        </div>
        <div className="m-5">
          <ControllerInput
            control={control}
            name="montoCompromiso"
            error={errors?.montoCompromiso}
            placeholder="Monto Compromiso"
            onlyNumbers={true}
          />
        </div>
        <div className="m-5">
          <ControllerTextArea
            control={control}
            name="observaciones"
            placeholder="Observaciones"
            error={errors?.observaciones}
          />
        </div>
        {message ? <div className="m-5 text-red-400">{message}</div> : ''}
        <Button label={'Guardar'} color="success" onClick={handleSubmit(submit)} loading={loader} />
        <Button label="Cancelar" onClick={() => closeModal()} />
      </div>
    </Card>
  );
};

CompromisoModal.propTypes = {
  changeState: PropTypes.func,
  actionOK: PropTypes.func,
  stateModal: PropTypes.string,
  title: PropTypes.string,
  params: PropTypes.object,
  id: PropTypes.string,
  labelReject: PropTypes.string
};

export default CompromisoModal;
